module.exports = __webpack_public_path__ + "img/user_login_bg.bf17dafa.png";